/* eslint-disable */
/**
 * Pengelola branding website Arena Sport Digital.
 */

const STORAGE_KEY = 'arspo_active_event';

// Pastikan branding website tidak pernah tertimpa oleh event
if (typeof window !== 'undefined') {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // abaikan galat kuota penyimpanan
  }
}

export function getActiveEvent() {
  return null;
}

export function setActiveEvent(event) {
  if (!event || !event.id) return;
  const payload = {
    id: event.id,
    name: event.name || event.nama || '',
    logo_url: event.logo_url || event.logo || null,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    // Ignore storage quota
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('arspo:event-changed', { detail: payload }));
  }
}

export function clearActiveEvent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // Ignore
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('arspo:event-changed', { detail: null }));
  }
}
